import React from 'react';
import {Typography} from 'antd';
import Wrapper from 'Components/Wrapper';
import Strings from 'Utils/constants/Strings';

const Texts = {...Strings.NoMemberData};

const NoMemberData = () => {
  return (
    <Wrapper>
      <Typography.Title
        data-testid="no-member-data-text"
        level={5}
        style={{padding: 32, textAlign: 'center', margin: 0}}>
        {Texts.PleaseSearchForMember}
      </Typography.Title>
    </Wrapper>
  );
};

export default NoMemberData;
